import { useGetWorkAreaTreeSuspense } from "@/orval/gen"
import { EmptyTreeNode } from "@/orval/gen/model"
import { useMemo } from "react"

function parseDepartmentId(value: string) {
  const match = /^DepartmentId-?(\d+)$/.exec(value)
  return match ? Number.parseInt(match[1], 10) : undefined
}

function collectSelectedDepartmentIds(
  nodes: EmptyTreeNode[],
  selectedNodes: Set<string>,
  parentDepartmentId: number | undefined,
  result: Set<number>
) {
  for (const node of nodes) {
    const departmentId = parseDepartmentId(node.value) ?? parentDepartmentId

    if (selectedNodes.has(node.value) && departmentId !== undefined) {
      result.add(departmentId)
    }

    collectSelectedDepartmentIds(
      node.children,
      selectedNodes,
      departmentId,
      result
    )
  }
}

export function useSelectedDepartmentIds(departmentTreeNodes: string[]) {
  const { data: workAreaTree } = useGetWorkAreaTreeSuspense()

  return useMemo(() => {
    const result = new Set<number>()
    collectSelectedDepartmentIds(
      workAreaTree.tree,
      new Set(departmentTreeNodes),
      undefined,
      result
    )
    return Array.from(result)
  }, [departmentTreeNodes, workAreaTree.tree])
}
